/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairtemperature2Inputs */



/**
* | output |
* | --- |
* | "Supply air temperature" |
*
* @param {Ahu_History_Key_Supplyairtemperature2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairtemperature2 = /** @type {((inputs?: Ahu_History_Key_Supplyairtemperature2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairtemperature2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air temperature")
	return /** @type {LocalizedString} */ ("Température air soufflé")
});
export { ahu_history_key_supplyairtemperature2 as "ahu_history_key_supplyAirTemperature" }